import type { Pdf } from "./schema";
import { BaseElementProvider, ElementProps, ToolbarProps } from "elements/base/provider";
import type { ElementController } from "elements/base/controller";
import React from "react";
import consts, { TypeCanvasElement } from "shared/consts";
import type { BoardContext } from "elements/index";
import PdfController from "./controller";
import PdfElementComponent from "./pdf-component";
import PdfToolbar from "./toolbar/pdf-toolbar";

export default class PdfElementProvider extends BaseElementProvider<Pdf> {
  getType(): TypeCanvasElement {
    return consts.CANVAS_ELEMENTS.PDF;
  }

  getElementRenderer(): React.FC<ElementProps<Pdf>> {
    return PdfElementComponent;
  }

  getToolbarRenderer(): React.FC<ToolbarProps<Pdf>> {
    return PdfToolbar;
  }

  createController(
    id: string,
    element: Pdf,
    context: BoardContext,
    _allElementsData: [string, any][] = []
  ): ElementController<Pdf> {
    return new PdfController(id, element, context);
  }

  isConnectorsEnabled(): boolean {
    return true;
  }

  isVotingEnabled(): boolean {
    return true;
  }

  isFFEnabled(): boolean {
    return true;
  }

  isRotationEnabled(): boolean {
    return true;
  }

  isLinkBadgeEnabled(): boolean {
    return true;
  }
}
